import { createSetupError } from '../utils/error';
export var styled = new Proxy({}, {
    get: function () {
        return function () {
            // Blow up if the transformer isn't turned on.
            // This code won't ever be executed when setup correctly.
            throw createSetupError();
        };
    },
});
//# sourceMappingURL=index.js.map